// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation_container__nt2HM","count":"navigation_count__p1llU","logo":"navigation_logo__ZxjYJ","span":"navigation_span__A9qBx"};